module.exports = __webpack_public_path__ + "img/normal_multiplier_7.eca94a9b.png";